/*!
 * Responsive Orientation
 */

// Get MediaQuery objects to listen to orientation and width
if (matchMedia) {
    var mediaQueryLandscape = window.matchMedia("(orientation: landscape)");
    var mediaQueryLarge = window.matchMedia("(min-width: 768px)");

    mediaQueryLandscape.addListener(changeFormat);
    mediaQueryLarge.addListener(changeDevice);
}

// Define list of all actions to be taken upon some change
var changes = {
    large: [],
    small: [],
    landscape: [],
    portrait: []
};

// Check if an action is a function
function isFunction(object) {
    return typeof(object) === 'function';
}

// Execute an action if it is a function
function exec(object) {
    if (isFunction(object)) {
        object();
    } else {
        console.log("NOT A FUNCTION:");
        console.log(object);
    }
}

// Call execution of all actions related to changing of width
var isLarge = mediaQueryLarge.matches;
function changeDevice() {
    isLarge = mediaQueryLarge.matches;
    if (isLarge) {
        changes.large.forEach(function(o){
            exec(o);
        });
    } else {
        changes.small.forEach(function(o){
            exec(o);
        });
    }
}


// Call execution of all actions related to changing of format
var isLandscape = mediaQueryLandscape.matches;
function changeFormat() {
    isLandscape = mediaQueryLandscape.matches;
    if (isLandscape) {
        changes.landscape.forEach(function(o){
            exec(o);
        });
    } else {
        changes.portrait.forEach(function(o){
            exec(o);
        });
    }
}

makeNavbarStatic = function() {
    jQuery(".mobileHeader").removeClass("mm-slideout").prependTo(".headerSection");
};

makeNavbarFixed = function() {
    jQuery(".mobileHeader").addClass("mm-slideout").insertAfter("#mm-mmenu");
};

changes.landscape.push(makeNavbarStatic);
changes.portrait.push(makeNavbarFixed);
